module.exports = __webpack_public_path__ + "db55dceaba26bb1ab124ff133cc3b6bd.webp";